import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { PlacenameService, NotificationService } from '@services';
import { Placename } from '../models/placename.model';
import { catchError, of } from 'rxjs';

export const placenameResolver: ResolveFn<Placename | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const placenameService = inject(PlacenameService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const placenameId = route.paramMap.get('id');
  if (!placenameId) {
    return of(null);
  }

  return placenameService.get(placenameId).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          }).finally(() => {
            notificationService.error('Failed to load the placename.');
          });
          break;
      }

      return of(null);
    }),
  );
};
